import { FormInfoField } from "./forminfofield";

export class FormInfo {

    public name: string;
    public fields: FormInfoField[];

    constructor(fields: FormInfoField[], name: string) {
        this.fields = fields;
        this.name = name;
    }
}
